<template>
  <nav class="navbar navbar-expand-lg navbar-light fixed-top stroke">
      <div class="container-fluid nav-content-container">

      <a class="navbar-brand" href="#">
        <router-link class="nav-link active" aria-current="page" to="/"><img src="@/assets/images/logo1.png" alt=“logo”
                                                                             height="40"/></router-link>
      </a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02"
              aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
        <span class="bi-text-right"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link class="nav-link active" aria-current="page" to="/">{{ $t("c.menu") }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link active" aria-current="page" to="/business">{{ $t("m.menu") }}</router-link>
          </li>

        </ul>

        <a :href="merchantPortalUrl">
          <center>
                      <div class="kokoWebButtons text-center mb-3" v-if="showMerchantLogin">
                Merchant Login
              </div>

            </center>
          </a>
          <form>
            <!-- locale changer -->
            <div class="locale-changer mb-3">

              <select v-model="$i18n.locale" class="form-select" aria-label="Default select example">
                <option class="dropdown-item" key='en' value='en'>English</option>
                <option class="dropdown-item" key='sin' value='sin'>සිංහල</option>
                <option class="dropdown-item" key='tam' value='tam'>தமிழ்</option>
              </select>
            </div>
          </form>

        </div>
      </div>
    </nav>
</template>

<script>

export default {
  name: 'locale-changer',
  data() {
    return { 
      langs: ['en', 'sin', 'tam'] ,
      merchantPortalUrl: process.env.VUE_APP_MERCHANT_PORTAL_BASE_URL
    };
  },
  props: {
    showMerchantLogin: {
      type: Boolean,
      default:false
    }
  }
}
</script>

<style scoped>

.nav-content-container {
  background-color: #ffffff;
}

nav-item {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

a {
  text-decoration: none;
}

nav-item a {
  text-decoration: none;
}

nav a.router-link-exact-active {
  color: #42b983;
  text-decoration: none;
  font-weight: bold;
}

locale-changer {
  position: fixed;
}

collapse navbar-collapse {
  float: right;
}

nav-link {
  float: right;
}

/* nav-bar hover feature */
nav.stroke ul li a,
nav.fill ul li a {
  position: relative;
}

nav.stroke ul li a:after,
nav.fill ul li a:after {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 0%;
  content: '.';
  color: transparent;
  background: #ffffff;
  height: 1px;
}

nav.stroke ul li a:hover:after {
  width: 100%;
}

.navbar-container {
  padding-left: 10px;
  padding-right: 10px;
}

.kokoWebButtons {
  background-color: #000000;
  padding-top: 7px;
  color: #FFFFFF;
  border: 0;
  height: 35px;
  width: 200px;
  margin-right: 10px;
  border-radius: 8px;
}

</style>